import PropTypes from 'prop-types';
import MaterialFormElement from './material_form_element';

// Fixed input to render Checkboxes better
export class MaterialInput extends MaterialFormElement {
  static propTypes = {
    includeInputHelper: PropTypes.bool
  }

  static defaultProps = {
    includeInputHelper: true,
    labelClassName: 'string fg-label form-label',
    className: 'string form-control-sm fg-input form-control',
    groupClassName: 'form-group fg-float string',
    wrapperClassName: 'fg-line'
  }

  renderChildren = () => {
    return !this.isCheckboxOrRadio() ? [
      this.renderWrapper([
        this.renderInputGroup([ this.renderInput() ]),
        this.renderLabel(),
        this.renderIcon()
      ]),
      this.renderHelp()] :
      this.renderWrapper([
        this.renderCheckboxAndRadioWrapper([
          this.renderInput(),
          this.renderInputHelper(),
          this.renderLabel()
        ]),
        this.renderHelp()
      ]);
  };
}
